import { Title } from 'Mri.Web.Common';
import * as React from 'react';

export class NotFound extends React.Component {
    public render() {
        return (
            <div className="container-fluid h-100" id="not-found">
                <Title>SmartVu®</Title>

                <div className="row h-100">
                    <div className="col-12 text-center pt-5">
                        <h1 data-heading="404">404</h1>
                        <h3>Page not found</h3>
                        <h4>Whoops! Looks like we fell off the map</h4>
                    </div>
                </div>
            </div>
        );
    }
}
